import React, { useEffect, useMemo, useRef } from "react";

import { useAlternativeProducts } from "../../../hooks/useAlternativeProducts";
import { useSelectedAlternativeProduct as useSelectedAlternativeProductCode } from "../../../hooks/useSelectedAlternativeProduct";
import { BottomMenuPanel } from "../../bottom-menu-panel";
import { BottomMenuButton } from "../../bottom-menu/bottom-menu-button";
import { BottomMenuButtons, IBottomMenuButtonsRef } from "../../bottom-menu/buttons";
import { useSelectedAlternativeProductGroupState } from "./hooks";
import { useSetAlternativeProduct } from "../../../hooks/useSetAlternativeProduct";
import { AlternativeIcon } from "../../alternative-icon/alternative-icon";
import { useErrorHandling } from "../../../hooks/useErrorHandling";

export const AlternativeProductsBottomMenuPanel = () => {
	const bottomMenuRef = useRef<IBottomMenuButtonsRef>(null);
	const { createErrorHandler } = useErrorHandling();
	const [alternativeProductGroup] = useSelectedAlternativeProductGroupState();

	const { alternativeProductsGroups } = useAlternativeProducts();

	const selectedAlternativeProductCode = useSelectedAlternativeProductCode();

	const newAlternativeProductsGroup = useMemo(() => {
		return alternativeProductsGroups?.find(
			(group) => group.name === alternativeProductGroup?.name,
		);
	}, [alternativeProductGroup?.name, alternativeProductsGroups]);

	const { setAlternativeProductAsync } = useSetAlternativeProduct();

	useEffect(() => {
		const index = newAlternativeProductsGroup?.alternativeProducts.findIndex(
			(newProduct) => newProduct.alternativeProductCode === selectedAlternativeProductCode,
		);

		if (index !== undefined && index >= 0)
			bottomMenuRef.current?.scrollIntoView(index, { animate: false });
		// eslint-disable-next-line react-compiler/react-compiler
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [newAlternativeProductsGroup?.alternativeProducts]);

	useEffect(() => {
		const index = newAlternativeProductsGroup?.alternativeProducts.findIndex(
			(newProduct) => newProduct.alternativeProductCode === selectedAlternativeProductCode,
		);

		if (index !== undefined && index >= 0) bottomMenuRef.current?.scrollIntoView(index);
		// eslint-disable-next-line react-compiler/react-compiler
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedAlternativeProductCode]);

	if (!newAlternativeProductsGroup) return null;

	return (
		<BottomMenuPanel>
			<BottomMenuButtons ref={bottomMenuRef}>
				{newAlternativeProductsGroup.alternativeProducts.map(
					({ name, alternativeProductCode, icon, orientation }) => (
						<BottomMenuButton
							onClick={() => {
								setAlternativeProductAsync(
									alternativeProductCode,
									newAlternativeProductsGroup,
								).catch(createErrorHandler());
							}}
							title={name}
							key={alternativeProductCode}
							isActive={selectedAlternativeProductCode === alternativeProductCode}
						>
							{icon?.svgUrl &&
							newAlternativeProductsGroup.style !==
								eXpress.core.ListViewStyle.Dropdown ? (
								<AlternativeIcon
									svgUrl={icon.svgUrl}
									color={icon.color}
									overlayColor={icon.overlayColor}
									orientation={orientation}
								/>
							) : null}
						</BottomMenuButton>
					),
				)}
			</BottomMenuButtons>
		</BottomMenuPanel>
	);
};
